module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data","lastUpdateOilPrice":"Last Update","oilPrice":"Oil price"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/share.json
// module id = 691
// module chunks = 63